<template>
  <div>
    <h1>Labs</h1>
    <div v-if="!labs_list">
      <h4>Retrieving labs list...</h4>
    </div>
    <div v-else-if="labs_list.length == 0">
      <h4>There are no labs yet.</h4>
    </div>
    <div v-else>
      <table class="unlined-table">
        <tr v-for="lab in labs_list" v-bind:key="lab.name">
          <td>
            <router-link :to="'../writeup/lab/' + lab.file">{{ lab.name }}</router-link>
          </td>
          <td>Due {{ lab.due }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Labs',
  data() {
    return {
      labs_list: null
    }
  },
  mounted() {
    axios.get("manifests/labs.json")
      .then(response => {
        this.labs_list = response.data;
      });
  }
};
</script>